import { ServiceApi } from "@/services/auth";

const state = {
  modulesState: [],
  loading: false,
  error: null,
};

const actions = {
  async fetchModules({ commit }, payload) {
    commit("SET_MODULES", []);
    try {
      commit("ModulesBegin");
      let response = await ServiceApi.get("/api/v1/modules", payload);
      commit("SET_MODULES", response.data);
      commit("modulesSuccess", true);
      return response;
    } catch (err) {
      commit("modulesErr", err);
    }
  },
  async storeModule({ commit, dispatch }, payload) {
    try {
      commit("ModulesBegin");
      if (!payload.id) {
        const resp = await ServiceApi.post("/api/v1/modules", payload);
        commit("SET_NEW_MODULES", resp.data);
        commit("modulesSuccess", true);
        return resp;
      } else if (payload.id) {
        const resp = await ServiceApi.put(
          `/api/v1/modules/${payload.id}`,
          payload
        );
        await dispatch("fetchModules");
        commit("modulesSuccess", true);
        return resp;
      }
    } catch (err) {
      commit("modulesErr", err);
    }
  },
  async deleteModules({ commit }, payload) {
    try {
      commit("ModulesBegin");
      const resp = await ServiceApi.delete(`/api/v1/modules/${payload}`);
      commit("SET_DELETE_MODULES", payload);
      commit("modulesSuccess", true);
      return resp;
    } catch (err) {
      commit("modulesErr", err);
    }
  },
};

const getters = {
  getModules: (state) => state.modulesState,
  modulesLoading: (state) => state.loading,
};

const mutations = {
  SET_MODULES(state, payload) {
    state.modulesState = payload;
  },
  SET_NEW_MODULES(state, payload) {
    state.modulesState.unshift(payload);
  },
  SET_DELETE_MODULES(state, payload) {
    state.modulesState = state.modulesState.filter(
      (item) => item.id !== payload
    );
  },
  ModulesBegin(state) {
    state.loading = true;
  },
  modulesSuccess(state) {
    state.loading = false;
  },
  modulesErr(state, err) {
    state.loading = false;
    state.error = err;
  },
};

export default {
  namespaced: false,
  state,
  actions,
  mutations,
  getters,
};
